import { CSSProperties, ReactNode } from "react";
import { Box } from "src/components/MuiGenerals";

function LabelValuePair({
  label,
  value,
  gridTemplateColumns,
  valueFontSize,
}: {
  label: string;
  value: string | number | string[] | ReactNode;
  gridTemplateColumns?: CSSProperties["gridTemplateColumns"];
  valueFontSize?: CSSProperties["fontSize"];
}) {
  return (
    <Box
      sx={{
        display: "grid",
        fontSize: "13px",
        gap: "8px",
        gridTemplateColumns:
          gridTemplateColumns || "minmax(9rem, max-content) 1fr",
        lineHeight: 1.5,
      }}
    >
      <div>{label}</div>
      {Array.isArray(value) ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            // gap: "2px",
            fontSize: valueFontSize || "13px",
          }}
        >
          {value.map((item, index) => (
            <div key={index}>{item}</div>
          ))}
        </div>
      ) : (
        <div
          style={{
            overflowWrap: "anywhere",
            // overflowWrap: "break-word",
            fontSize: valueFontSize || "13px",
          }}
        >
          {value}
        </div>
      )}
    </Box>
  );
}

export default LabelValuePair;
